import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header/index.js";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";

import march2024 from "./components/Body/march2024.json";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";

// Lazy-loaded components
const Footer = lazy(() =>
  import("./components/CommenFooterComponent/index.js")
);
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() =>
  import("./components/Morganlogos/Morganlogos.js")
);
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));
const Testimonial = lazy(() =>
  import("./components/Testimonials/Testimonials.js")
);

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [EventsData, setEventsData] = useState();
  const [formData, setFormData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [links, setLinks] = useState(null);
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink || "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Import local JSON file instead of fetching from CDN
        const webinarJsonData = march2024;
        setWebinarData(webinarJsonData);
        setBannerData(webinarJsonData.banner);
        setHighlightsData(webinarJsonData.highlights);
        setPropertyData(webinarJsonData.property);
        setEventsData(webinarJsonData.Events);
        setFormData(webinarJsonData.signupform);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error or set default data
      }
    };

    fetchData();

    const fetchLinks = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_CDN_LINK + "jsons/ai-branding.json"
        );
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData);
      }
    };

    if (!links) {
      fetchLinks();
    }
  }, []); // Remove links dependency since we're not fetching it asynchronously

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <>
          <Header fetchpriority="high" aiBrandingData={aiBrandingData} />
          {bannerData && (
            <Body
              bannerData={bannerData}
              formData={formData}
              links={links}
              fetchpriority="high"
            />
          )}
          <Suspense fallback={<div />}>
            {highlightsData && (
              <Highlights highlightsData={highlightsData} links={links} angelAiLink={angelAiLink}/>
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            {propertyData && (
              <Proprty propertyData={propertyData} links={links} />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            {EventsData && links ? (
              <EventComponent
                EventsData={EventsData}
                angelAiLink={angelAiLink}
                sunwestLink={sunwestLink}
                links={links}
                fetchpriority="low"
              />
            ) : (
              <Spinner animation="border" role="status" />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            <Testimonial
              links={links}
              angelAiLink={angelAiLink}
              fetchpriority="low"
            />
          </Suspense>
          <Suspense fallback={<div />}>
            {links && (
              <Morganlogos
                links={links}
                angelAiLink={angelAiLink}
                sunwestLink={sunwestLink}
                fetchpriority="low"
              />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            {links && (
              <Whysunwest
                links={links}
                angelAiLink={angelAiLink}
                swmcLink={swmcLink}
                pavanLink={pavanLink}
                sunwestLink={sunwestLink}
                fetchpriority="low"
              />
            )}
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </>
      </CacheBuster>
    </div>
  );
}

export default App;
